import { jsx as r } from "react/jsx-runtime";
import { useTranslation as x, getUrlSchemeOptions as f, Hint as p } from "@systemeio/ui";
import { useTranslation as F } from "./i18n.mjs";
import { TipTapEditor as c } from "./tip-tap.mjs";
import { EditorExtensionEnum as o } from "./enums/editor-extensions-enum.mjs";
import { getEmailFontFamilyOptionsData as E, FontFamilyEnum as O } from "./extensions/font-family-extension/utils.mjs";
import { FileSourceEnum as u } from "@systemeio/file-manager";
const C = (t) => {
  var e, a, l, m, s;
  const { t: i } = F(), { t: n } = x();
  return /* @__PURE__ */ r(
    c,
    {
      defaultFont: O.Arial,
      ...t,
      extensionOptions: {
        ...t.extensionOptions,
        [o.Image]: {
          ...(e = t.extensionOptions) == null ? void 0 : e[o.Image],
          schemeOptions: f(n),
          fileSource: u.Email
        },
        [o.Link]: {
          ...(a = t.extensionOptions) == null ? void 0 : a[o.Link],
          schemeOptions: f(n),
          fileSource: u.Email
        },
        [o.TextColor]: {
          ...(l = t.extensionOptions) == null ? void 0 : l[o.TextColor],
          showAlpha: !1
        },
        [o.TextBackgroundColor]: {
          ...(m = t.extensionOptions) == null ? void 0 : m[o.TextBackgroundColor],
          showAlpha: !1
        },
        [o.FontFamily]: {
          ...(s = t.extensionOptions) == null ? void 0 : s[o.FontFamily],
          fontFamilyOptionsData: E(i),
          noFontFamilyElement: /* @__PURE__ */ r(p, { label: i("font_family.mailbox_default_hint"), children: i("font_family.mailbox_default") })
        }
      }
    }
  );
};
export {
  C as TipTapEmailEditor
};
